import pako from 'pako';

import { tenantId } from '../settings';
import { addQueryStringData } from '../util/url';

export const udsUrl = 'https://uds.documents.cimpress.io';

export function createBasicUdsDocument({ url, width, height, colorAdjustment = {} }) {
    return {
        version: '2.0',
        document: {
            surfaces: [{
                name: 'dummy-name',
                height,
                width,
                images: [{
                    id: 'id',
                    printUrl: url,
                    previewUrl: url,
                    position: {
                        x: 0,
                        y: 0,
                        height,
                        width,
                    },
                    colorAdjustment,
                }],
            }],
        },
    };
}

export function getTransientUdsDocument(udsDoc, type = 'preview') {
    const udsDocJson = JSON.stringify(udsDoc);
    const deflatedDoc = pako.deflateRaw(udsDocJson, { to: 'string' });
    const baseEncodedDoc = btoa(deflatedDoc);
    const transientUrl = `${udsUrl}/v2/transient/${tenantId}`;
    return addQueryStringData(transientUrl, { document: baseEncodedDoc, type });
}

export function getBasicTransientUdsDocument(docProps) {
    return getTransientUdsDocument(createBasicUdsDocument(docProps));
}



// WEBPACK FOOTER //
// ./src/services/udsClient.js